import React from 'react';

interface BulletListItemProps {
  children: React.ReactNode;
}

export const BulletListItem: React.FC<BulletListItemProps> = ({ children }) => {
  return (
    <div style={{display: 'flex', gap: '8px'}}>
      <span>•</span>
      <span>{children}</span>
    </div>
  );
};

